/* src/app/not-found/not-found.component.css */
.notice-container {
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
  align-content: center;
  justify-content: center;
  height: 100%;
}
.notice-container > div {
  width: 400px;
  margin: auto;
  text-align: center;
  padding: 20px 20px 20px 20px;
}
.mt {
  margin-top: 20px;
}
.rounded-button a a:visited a:link {
  color: white;
}
.sorry-title {
  font-size: 24px;
  color: var(--primary-color);
  margin-bottom: 20px;
}
.top-border-box {
  border-top-color: var(--secondary-color);
  border-top-style: solid;
  border-top-width: 3px;
  border-left-style: none;
  border-right-style: none;
  border-bottom-style: none;
  color: var(--primary-color);
  padding-top: 20px;
}
/*# sourceMappingURL=not-found.component.css.map */
